/**
 * Revenue Control Center Route
 *
 * CEO/CMO/CRO command dashboard for all growth, revenue, pricing, and funnel intelligence
 */

import { createFileRoute } from '@tanstack/react-router';
import { RevenueControlCenter } from '@/components/revenue-control-center';
import { AdminLayout } from '@/components/admin/AdminLayout';

export const Route = createFileRoute('/admin/revenue-control-center')({
  component: RevenueControlCenterPage,
});

function RevenueControlCenterPage() {
  return (
    <AdminLayout>
      <RevenueControlCenter />
    </AdminLayout>
  );
}
